import React from 'react';
import * as BREAKPOINTS from '@zola/zola-ui/src/styles/emotion/mediaQuery';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { HighlightTitle } from '@zola/zola-ui/src/components/PreAuthV3';

import getSourceElements, { ImageType } from 'libs/client/Image/getSourceElements';

import {
  ButtonWrapper,
  ContentWrapper,
  HeroImage,
  HeroSection,
  MediaContainer,
} from './Hero.styles';

import Mobile from '../../../../../public/static-preauth/images/WeddingPlanningLP/heroV3/mobile.jpg';
import Tablet from '../../../../../public/static-preauth/images/WeddingPlanningLP/heroV3/tablet.jpg';
import Desktop from '../../../../../public/static-preauth/images/WeddingPlanningLP/heroV3/desktop.jpg';
import DesktopXL from '../../../../../public/static-preauth/images/WeddingPlanningLP/heroV3/desktop_xl.jpg';

import MobileWebp from '../../../../../public/static-preauth/images/WeddingPlanningLP/heroV3/mobile.webp';
import TabletWebp from '../../../../../public/static-preauth/images/WeddingPlanningLP/heroV3/tablet.webp';
import DesktopWebp from '../../../../../public/static-preauth/images/WeddingPlanningLP/heroV3/desktop.webp';
import DesktopXLWebp from '../../../../../public/static-preauth/images/WeddingPlanningLP/heroV3/desktop_xl.webp';

const HeroImages: ImageType = {
  webp: [
    { url: MobileWebp, maxBreakpoint: (BREAKPOINTS.SCREEN_SM - 1).toString() },
    { url: TabletWebp, maxBreakpoint: (BREAKPOINTS.SCREEN_MD - 1).toString() },
    { url: DesktopWebp, maxBreakpoint: (BREAKPOINTS.SCREEN_XL - 1).toString() },
    { url: DesktopXLWebp, minBreakpoint: BREAKPOINTS.SCREEN_XL.toString() },
  ],
  jpg: [
    { url: Mobile, maxBreakpoint: (BREAKPOINTS.SCREEN_SM - 1).toString() },
    { url: Tablet, maxBreakpoint: (BREAKPOINTS.SCREEN_MD - 1).toString() },
    { url: Desktop, maxBreakpoint: (BREAKPOINTS.SCREEN_XL - 1).toString() },
    { url: DesktopXL, minBreakpoint: BREAKPOINTS.SCREEN_XL.toString() },
  ],
};

const Hero: React.FC = (): JSX.Element => {
  return (
    <HeroSection>
      <MediaContainer>
        <picture>
          {getSourceElements(HeroImages.webp, 'webp')}
          {getSourceElements(HeroImages.jpg, 'jpg')}
          <HeroImage src={Desktop} alt="" />
        </picture>
      </MediaContainer>
      <ContentWrapper>
        <HighlightTitle>
          Your free <span>wedding planning suite</span>
        </HighlightTitle>
        <ButtonWrapper>
          <ButtonV3 component="a" href="/wedding/onboard/wedding-planning" size="large">
            Let&apos;s go
          </ButtonV3>
        </ButtonWrapper>
      </ContentWrapper>
    </HeroSection>
  );
};

export default Hero;
